import React from 'react';

interface AvatarProps {
  src?: string | null;
  alt?: string;
  fallback?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

// Different DiceBear styles for variety
const AVATAR_STYLES = [
  'adventurer',
  'adventurer-neutral', 
  'avataaars',
  'big-ears',
  'big-smile',
  'bottts',
  'croodles',
  'fun-emoji',
  'lorelei',
  'micah',
  'miniavs',
  'notionists',
  'open-peeps',
  'personas',
  'pixel-art',
];

// Get consistent style based on seed
const getAvatarStyle = (seed: string) => {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = seed.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_STYLES[Math.abs(hash) % AVATAR_STYLES.length];
};

export const Avatar: React.FC<AvatarProps> = ({
  src,
  alt = 'Avatar',
  fallback,
  size = 'md',
  className = '',
}) => {
  const sizes = {
    xs: 'w-6 h-6 text-xs',
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base',
    lg: 'w-12 h-12 text-lg',
    xl: 'w-16 h-16 text-xl',
  };

  // Generate DiceBear avatar URL with varied styles if no src provided
  const seed = fallback || alt;
  const style = getAvatarStyle(seed);
  const avatarUrl = src || `https://api.dicebear.com/7.x/${style}/svg?seed=${encodeURIComponent(seed)}&backgroundColor=0f172a`;

  return (
    <div
      className={`
        ${sizes[size]} rounded-full overflow-hidden border-2 border-slate-700
        bg-slate-800 flex items-center justify-center font-bold text-slate-400
        ${className}
      `}
    >
      <img
        src={avatarUrl}
        alt={alt}
        className="w-full h-full object-cover"
        onError={(e) => {
          // If image fails to load, show initials
          const target = e.target as HTMLImageElement;
          target.style.display = 'none';
          const parent = target.parentElement;
          if (parent && fallback) {
            parent.innerHTML = fallback.slice(0, 2).toUpperCase();
          }
        }}
      />
    </div>
  );
};

